<template>
  <div style="height:100%">
    <el-row class="title-bar mr-t10" type="flex" justify="space-between" style="height:31px">
      <div class="vertical-center-box">
        <div class="title-h4">장비 다운 연관 관계</div>
      </div>
    </el-row>
    <el-tree ref="tree" class="tree-w-stroke obj-tree" :data="treeData" :props="defaultProps" :node-key="defaultProps.treeKey" :expand-on-click-node="false"
    :default-expand-all="true" highlight-current @node-click="clickNode" style="border:1px solid #EBEEF5;padding:5px;height:calc(100vh - 502px);overflow:auto">
      <span class="el-tree-node__label" slot-scope="{ node, data }">
        <span class="obj-icon">
          <i :class="getObjTypeIconClass(data)"></i>
        </span>
        <span>{{data.label}}</span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import { isEmpty, isEqual, cloneDeep } from 'lodash';
import { defaultProps } from '@/constants/tree';
import { getObjTypeIconClass } from '@/utils/tree';
import EventHistAPI from '@/api/event/event-hist';

export default {
  name: 'WRootCauseTree',
  props: {
    objId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      defaultProps,
      treeData: [],
      objIds: [],
    };
  },
  watch: {
    objId: {
      handler(value) {
        if (value > 0) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    getObjTypeIconClass,
    loadData() {
      if (this.objId > 0) {
        EventHistAPI.getRootCauseChildList(this.objId).then((response) => {
          const result = response.data;
          if (result.success) {
            this.treeData = result.children;
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(this.treeData[0].treeKey);
              this.$emit('set-node-data', this.treeData[0]);
            });
          }
        });
      }
    },
    clickNode(data) {
      const nodeData = cloneDeep(data);
      if (nodeData.parentObjId > 0) {
        this.objIds = [nodeData.objId];
        this.setObjIds(nodeData);
        nodeData.objIds = this.objIds;
      }
      this.$emit('set-node-data', nodeData);
    },
    setObjIds(nodeData) {
      if (nodeData.parentObjId > 0) {
        const objIds = this.objIds;
        const children = nodeData.children;
        if (!isEmpty(children)) {
          children.forEach((item) => {
            objIds.push(item.objId);
          });
        }
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/event-hist/popup/RootCauseAnalysisPopup/components/RootCauseTree.vue